//	Ref: https://github.com/rangle/redux-beacon/blob/master/docs/targets/google-analytics.md
import { createMiddleware } from 'redux-beacon'
import GoogleAnalytics, { trackPageView, trackEvent } from '@redux-beacon/google-analytics'
import eventsMap from './eventsMap'

const googleAnalyticsMiddleware = createMiddleware(eventsMap(trackPageView, trackEvent), GoogleAnalytics(global.googleAnalyticsAccount))

export default googleAnalyticsMiddleware



// WEBPACK FOOTER //
// ./src/analytics/googleAnalyticsMiddleware.js